<template>
    <component v-if="itemDefinition" v-bind:is="itemDefinition.viewType" v-bind:itemDefinition="itemDefinition"></component>
</template>

<script>
    import PlotList from "./automated/PlotList";
    import PlotListFS from "./automated/PlotListFS.vue";
    import {mapGetters} from 'vuex'

    export default {
        name: 'CustomViewRenderer',
        components: {PlotList, PlotListFS},
        computed: {
            ...mapGetters([
                'publishedCustomViews',
            ]),
            itemDefinition() {
                for (let item of this.publishedCustomViews){
                    if(item.id===this.$route.params.id){
                        let scopedItem = JSON.parse(JSON.stringify(item))
                        if (scopedItem.renderInFullScreen) {
                            scopedItem.viewType = 'PlotListFS'
                        }
                        return scopedItem
                    }
                }
                return null
            },
        }
    }
</script>
